module.exports = __webpack_public_path__ + "img/TokoCrypto.fca174f7.png";